import React from 'react';

function Pointer({ hex }) {
  return <div className="ws-ui-color-picker__pointer" style={{ backgroundColor: hex }} />;
}

export default Pointer;
